import { Box, CardMedia } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import CarPlaceholder from '../../public/assets/CarPlaceholder.png';

const PREFIX = 'ImageContainer';

const classes = {
  imageContainer: `${PREFIX}-imageContainer`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.imageContainer}`]: {
    width: '100%',
    borderRadius: '4px',
    overflow: 'hidden',
    marginRight: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[100]}`,
  },
}));

const ImageContainer = ({ maxWidth = '100%' }) => {
  return (
    <StyledBox
      className={classes.imageContainer}
      style={{ maxWidth: maxWidth }}
    >
      <CardMedia
        component="img"
        alt="Car placeholder image"
        height="inherit"
        image={CarPlaceholder}
        title="Car placeholder image"
      />
    </StyledBox>
  );
};

export default ImageContainer;
